export default __webpack_public_path__ + "static/FritzphoneC4_06-2e408574609155315799b6430448306a.webp";